import { AxiosService } from './axios.service'

/**
 * Defines the API methods for points exchange
 */
export default class PointsExchangeService {
	static baseURL = 'simulacao-de-pontos'

	/**
	 * List the origins
	 * @return {Promise<any>} The origin list
	 */
	static listOrigin() {
		return AxiosService.get(
			`${PointsExchangeService.baseURL}/listar-origem`
		).then(({ data }) => data)
	}

	/**
	 * Search the destination
	 * @return {Promise<any>} The destination list
	 */
	static searchDestination(params) {
		if (!params.origin) return Promise.resolve({ data: [] })

		return AxiosService.get(
			`${PointsExchangeService.baseURL}/buscar-destino`,
			{
				params
			}
		).then(({ data }) => data)
	}
}
